'use strict';

const React = require('react/addons'),
    {t} = require('services/i18nextWrapper'),
    SessionStore = require('stores/SessionStore'),
    UserStore = require('stores/UserStore'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    Loading = require('components/Commons/Loading/Loading'),
    Authentication = require('services/Security').Authentication,
    ContentUtils = require('utils/ContentUtils'),
    AppConstants = require('constants/AppConstants'),
    {Navigation} = require('react-router'),
    ga = require('react-ga'),
    get = require('lodash/object').get,
    {filter} = require('lodash/collection'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const UserAdmin = React.createClass({displayName: "UserAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        return {
            selectedItem: null,
            selectedItemId: null,
            isEditMode: false,
            isFetching: true
        };
    },

    componentDidMount() {
        this.fetchUsers();
        ga.pageview('User-admin');
    },

    fetchUsers() {
        const self = this;
        UserStore.fetchUsers(users => {
            users = users.map(user => {
               user.role = user.roles.includes('ADMIN') ? AppConstants.USERS_ROLES[0] : AppConstants.USERS_ROLES[1];
               return user;
            });
            self.setState({
                users: filter(users, user => get(user,'accountEnabled')),
                isFetching: false
            });
        });
    },


    _onDeleteUser(userId, onSuccess) {
        CustomDialog.showWarningConfirmation(t('warning'), t('user_admin_delete_question'), () => {
            UserStore.deleteUser(userId, onSuccess, this.__onFailureShowMessageError);
        });
    },

    _onChangeUser(User, onSuccess) {
        UserStore.changeUser(User, onSuccess, this.__onFailureShowMessageError);
    },

    _onAddUser(User, onSuccess) {
        UserStore.addUser(User, onSuccess, this.__onFailureShowMessageError);
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _goToChangePasswordPage() {
        this.transitionTo('/passwordRecovery',{},{userName: get(this.state, 'selectedItem.username')});
    },

    _getRoleText(text) {
       const isAdmin = text.roles.includes('ADMIN');
       return (React.createElement("span", null,  isAdmin ? AppConstants.getUserRoles(t)[0].displayText : AppConstants.getUserRoles(t)[1].displayText));
    },

    render() {
        if (!this.state.users) {
            return (React.createElement(Loading, null));
        } else {
            const messages = {
                changeSuccessMessage: t('user_admin_change_success_message'),
                changeFailureMessage: t('user_admin_change_failure_message'),
                deleteSuccessMessage: t('user_admin_delete_success_message'),
                addSuccessMessage: t('user_admin_add_success_message'),
                addFailureMessage: t('user_admin_add_failure_message')
            };
            const userRolMapping = AppConstants.getUserRolesMapping(t);
            const contextHolder = this.getContextHolderInstance();
            const {selectedItem, users, isEditMode} = this.state;
            const formFieldsEl = [
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "username", 
                    name: t('user_admin_label_username'), 
                    value: selectedItem, 
                    label: t('user_admin_label_username'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress, 
                    additionalValidation: validateUserName(t)}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "email", 
                    additionalValidation: inputValue => ContentUtils.isValidEmail(inputValue) ? '' : t('notification_define_valid_email'), 
                    isRelaxedText: true, 
                    name: t('email'), 
                    value: selectedItem, 
                    label: t('email'), 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                )
            ];

            if (!isEditMode) {
                formFieldsEl.push(
                    React.createElement(FormGroupTextfield, {
                        operationsHolder: contextHolder, 
                        readerAttribute: "password", 
                        isRelaxedText: true, 
                        name: t('password'), 
                        value: selectedItem, 
                        label: t('password'), 
                        isEditMode: isEditMode, 
                        onEnter: this._onEnterPress}
                    )
                );
            }

            formFieldsEl.push(
              React.createElement(FormGroupDropdown, {
                items: AppConstants.getUserRoles(t), 
                operationsHolder: contextHolder, 
                readerAttribute: "displayText", 
                customReaderWriterAttribute: "role", 
                readerAttributeValue: "role", 
                writerAttribute: "role", 
                outputMapper: {
                    Administrator: t('user_admin_label_rol_admin'),
                    Guest: t('user_admin_label_rol_guest')
                }, 
                name: t('user_admin_label_rol'), 
                isImmutable: selectedItem && selectedItem.principal, 
                value: selectedItem, 
                isEditMode: isEditMode, 
                onEnter: this._onEnterPress}
              )
            );
    
            const additionalButtons = [
                {
                    type: 'CHANGE',
                    permission: 'PERMISSION_EDIT',
                    el: (
                      React.createElement(FormGroupButton, {
                        label: t('user_admin_change_password'), 
                        icon: "subdirectory_arrow_right", 
                        type: "icon", 
                        onClick: this._goToChangePasswordPage}
                      )
                    )
                }
            ];

            return (
                React.createElement(AdminScaffolding, {
                    moduleName: "ADMIN_USER", 
                    messages: messages, 
                    title: t('users'), 
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    fetchItems:  this.fetchUsers, 
                    headerFields: formFieldsEl, 
                    onAdd:  this._onAddUser, 
                    additionalButtons: additionalButtons, 
                    onChange:  this._onChangeUser, 
                    onCancel:  this._onCancel, 
                    onDelete:  this._onDeleteUser, 
                    addEnterKeyDown: this._addEnterKeyDown, 
                    isDark: true 
                }, 
                    React.createElement("span", {style: {'color':'white','background-color': '#434445','padding-right': '15px','padding-left': '15px','display': 'flex','align-items': 'center','paddingBottom':'5px'}}, 
                        React.createElement("i", {className: "material-icons md-48", style: {'color':'white'}}, "info"), React.createElement("span", {style: {'padding':'0 0.5rem'}}, SessionStore.getApplicantEmail()), t('user_admin_label_company_email')
                    ), 
                    React.createElement(AdminScaffoldingTable, {
                        onRowSelection: this.__onRowSelection, 
                        value: selectedItem, 
                        filteredColumns: ['username', 'email', 'roles'], 
                        displayAttributes: ['username', 'email', { getHTML: this._getRoleText }], 
                        columnNames: [
                            t('user_admin_label_username'),
                            t('email'),
                            t('user_admin_label_rol')]
                    }, 
                        users.map(user => {
                            user.displayRole = userRolMapping[user.role];
                            return user;
                        })
                    )
                ));
        }
    }
});

function validateUserName(t) {
    return inputValue => (inputValue || '').match(/\s|[A-Z]/) === null ? '' : t('user_admin_error_inline_user_invalid');
}


module.exports = UserAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/UserAdmin/UserAdmin.jsx
 **/